var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CC94B690-FA32-4DC2-932A-213E7BF6CDE5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-930.000000, -1741.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(58.000000, 1545.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(860.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button/primary/icon/normal-copy-3",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24px/add",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0000584,4 C12.1487303,4 12.2866816,4.06912311 12.3742171,4.18316237 L12.4203709,4.25678221 L14.6386521,8.67398292 L19.5987459,9.38235294 C19.7753084,9.4075367 19.9219646,9.52909441 19.9770896,9.69589075 C20.0230792,9.8348621 19.998778,9.98515847 19.9154707,10.1022049 L19.8584959,10.1680862 L16.2690896,13.6064372 L17.1164959,18.4614054 C17.1466521,18.634252 17.0743084,18.8089413 16.9299646,18.9120104 C16.8096782,18.9979014 16.6567528,19.0216434 16.5177019,18.9799484 L16.4363084,18.9470527 L12.0000271,16.6548085 L7.56355838,18.9470834 C7.49499588,18.9825249 7.42012088,19 7.34549588,19 C7.24830838,19 7.15158963,18.9703323 7.06993338,18.9120411 C6.94964692,18.8261246 6.87938216,18.6905358 6.87677148,18.5476991 L6.88346463,18.4614668 L7.73058963,13.6064372 L4.14158963,10.168117 C4.01380838,10.04573 3.96780838,9.86265637 4.02296463,9.69586004 C4.06890213,9.55688868 4.1784464,9.44931171 4.3158444,9.4027391 L4.40133963,9.38235294 L9.36133963,8.67398292 L11.5797146,4.25678221 C11.6586834,4.09953727 11.8216209,4 12.0000584,4 Z M13.9796606,9.59001623 L12,5.648 L10.0203213,9.59001625 L5.636,10.216 L8.80734266,13.2531393 L8.054,17.567 L12.0000338,15.5292085 L15.945,17.567 L15.1923038,13.2531323 L18.362,10.215 L13.9796606,9.59001623 Z",
    id: "Path-Copy"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2458fded.svg";
export { ForwardRef as ReactComponent };